import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

import DriversContainer from "./DriversContainer";
import UsersContainer from "./UsersContainer";
import MerchantsContainer from "./MerchantsContainer";
import CustomersContainer from "./CustomersContainer";

const StatsTabShow = (props) => {
  const [key, setKey] = useState(
    props.history.location.search.replace("?", "") || "first"
  );
  const handleSelect = (k) => {
    setKey(k);
    props.history.push(`/stats?${k}`);
  };
  return (
    <Tab.Container
      className="mt-2"
      id="stats"
      activeKey={key}
      onSelect={(k) => handleSelect(k)}
      mountOnEnter
      unmountOnExit
    >
      <Row>
        <Col sm={2} className="pt-5">
          <Nav variant="tabs" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="first">Merchants</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second">Drivers</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="third">Users</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="fourth">Customers</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={10}>
          <div className="container-fluid">
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <MerchantsContainer />
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <DriversContainer />
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                <UsersContainer />
              </Tab.Pane>
              <Tab.Pane eventKey="fourth">
                <CustomersContainer />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default StatsTabShow;
